/**
 * Scroll a pool-play match card into view. Used after a pick is completed
 * (winner + score) to advance the user to the next incomplete match.
 *
 * The card wrapper carries data-pool-match-id={match.match_id}; we look up
 * the element and rely on scrollIntoView with smooth behavior. Mirrors the
 * single-elim auto-scroll (handleSelectWinner → scrollToMatch) in spirit
 * without needing the heavier useBracketScroll machinery.
 */
export function scrollToPoolMatch(match) {
  if (!match?.match_id || typeof document === 'undefined') return
  // requestAnimationFrame so React commit lands first; otherwise the smooth
  // scroll sometimes targets the pre-rerender position.
  requestAnimationFrame(() => {
    const el = document.querySelector(`[data-pool-match-id="${match.match_id}"]`)
    if (!el) return
    // 'nearest' scrolls the minimum needed to bring the next match into view.
    // 'center' overshot — it pushed the next card to mid-screen, scrolling
    // further down than necessary (owner report 2026-05-21).
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
  })
}
